export const onlyEmailRegex = /^[A-Z0-9.!#$%&'*+-/=?^_`{|}~]+@([A-Z0-9-]+\.)+[A-Z]{2,}$/i;
export const usPhoneRegex =
  /^(?:\+?1[\s-]?)?\(?[2-9]\d{2}\)?[\s\- ]?[2-9]\d{2}[\s-]?\d{4}[\s-]?\d{0,4}$/;
export const letterMatchingRegex = /[a-zA-Z]+/;
